import * as ng from 'angular';

import { UtilsService } from '../../../shared';

export class DashboardCustomizationEditor implements ng.IController {
   static $inject = ['utils', 'dialogs'];

   constructor(private utils: UtilsService, private dialogs) { }

   close:{({$value:any}):void};
   dismiss:{({$value:any}):void};

   dashboardWidget: any;

   resolve: {
      dashboardWidget: any
   };

   $onInit() {
      this.dashboardWidget = ng.copy(this.resolve.dashboardWidget);
   }

   cancel() {
      this.dismiss({$value: 'cancel'});
   }

   save(form:ng.IFormController) {
      form.$setSubmitted();

      if (form.$valid) {
         if (this.dashboardWidget.backgroundColor && !this.dashboardWidget.backgroundColor.startsWith('#')) {
            this.dashboardWidget.backgroundColor = '#' + this.dashboardWidget.backgroundColor;
         }

         if (this.dashboardWidget.color && !this.dashboardWidget.color.startsWith('#')) {
            this.dashboardWidget.color = '#' + this.dashboardWidget.color;
         }

         this.close({
            $value: this.dashboardWidget
         });
      }
   }
}

ng.module('e360').component('dashboardCustomizationEditor', {
   templateUrl: require('./dashboard-customization-editor.html'),
   controller: DashboardCustomizationEditor,
   bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
   }
});
